

















import Vue from 'vue'
import './SelfTest.scss'
import SelfTestMobile from '@/components/SelfTestMobile'
import { UserProfile } from '@/types/users'

export default Vue.extend({
  name: 'SelfTestView',
  created () {

  },
  computed: {
    currentUserId (): string {
      return this.$store.direct.state.user.id
    },
    userProfile (): UserProfile | null {
      return this.$store.direct.state.user.profile
    },
  },
  components: {
    SelfTestMobile
  }
})
